import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';

import StyledLink from '@makeship/core/lib/components/Link';
import posthog from 'posthog-js';
import Modal from '..';
import { Caption, S2 } from '../../Typography';
import { modalTheme } from '../../../styles/themes';

const ModalContent = styled.div`
  width: 100%;
  padding: 24px 24px 45px 24px;
  display: flex;
  flex-direction: column;
  border-radius: 50px;
  position: relative;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 24px;
  }
`;

const CancelIcon = styled.div`
  cursor: pointer;
  margin-left: auto;
`;

const ModalHeader = styled.div``;

const ImageDesktopWrapper = styled.div`
  display: block;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    display: none;
  }
`;

const ImageMobileWrapper = styled.div`
  display: none;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    display: block;
  }
`;

const TermsAndConditionsWrapper = styled.div`
  margin-top: 10px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    margin-top: 26px;
    margin-left: 0px;
  }
`;

const TermsTitle = styled(S2)``;

const TermsContent = styled(Caption)`
  margin-top: 10px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    margin-bottom: 60px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    margin-bottom: 20px;
  }
`;

const giftingModalTheme = {
  ...modalTheme,
  content: {
    ...modalTheme.content,
    width: '750px',
    borderRadius: '50px',
  },
};

type PrideModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  modalLocation: string;
};

const PrideModal: React.FC<PrideModalProps> = ({ isOpen, closeModal, modalLocation }: PrideModalProps) => (
  <Modal isOpen={isOpen} onRequestClose={closeModal} theme={giftingModalTheme}>
    <ModalContent>
      <CancelIcon onClick={closeModal}>
        <Image src="/assets/icons/cancel-icon.svg" width="16" height="16" quality={90} alt="close" />
      </CancelIcon>
      <ModalHeader>
        <ImageDesktopWrapper>
          <Image
            src="/assets/pride2025/PRIDE25_Logo-Lockup_black.png"
            width={339}
            height={127}
            quality={90}
            alt="Pride 2025 brought to you in support of The Trevor Project"
          />
        </ImageDesktopWrapper>
        <ImageMobileWrapper>
          <Image
            src="/assets/pride2025/PRIDE25_Logo-Lockup_black.png"
            width={275}
            height={103}
            quality={90}
            alt="Pride 2025 brought to you in support of The Trevor Project"
          />
        </ImageMobileWrapper>
      </ModalHeader>
      <TermsAndConditionsWrapper>
        <TermsTitle>Terms & Conditions</TermsTitle>
        <TermsContent>
          From Sunday June 1st 12pm ET to Monday June 30th 12pm ET (30 days), $1,000 will be donated per day (for a
          total of $30,000) to The Trevor Project. Additionally, for every purchase of the 2025 Pride Pin Set made
          online at{' '}
          <StyledLink.Primary
            onClick={() => posthog.capture('pride2025Modal_makeshipLink', { modalLocation })}
            href="/"
          >
            makeship.com
          </StyledLink.Primary>
          , Makeship will also donate 50% of retail sales to The Trevor Project. The Trevor Project is a United States
          501(c)(3) public charity whose mission is to end suicide among gay, lesbian, bisexual, transgender, queer, and
          questioning (LGBTQ+) young people. To learn more about The Trevor Project, visit{' '}
          <StyledLink.Primary
            onClick={() => posthog.capture('pride2025Modal_trevorProjectLink', { modalLocation })}
            href="https://www.thetrevorproject.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.thetrevorproject.org
          </StyledLink.Primary>
          . No portion of purchase is tax deductible. Makeship will receive no remuneration for conducting this
          campaign.
        </TermsContent>
      </TermsAndConditionsWrapper>
    </ModalContent>
  </Modal>
);

export default PrideModal;
